import { useMutation, useQueryClient } from "@tanstack/react-query";
import { serviceMapService } from "../../../services/serviceMapService";
import { businessServiceService } from "../../../services/businessServiceService";
import type { BusinessService } from "../../../types";

export const useUpdateService = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceMapId,
      systemId,
      system,
    }: {
      serviceMapId: string;
      systemId: string;
      system: Partial<BusinessService>;
    }) => {
      const id = await businessServiceService.patch(serviceMapId, systemId, system);
      await serviceMapService.updateServiceStatuses(id);
      return { serviceMapId, systemId };
    },
    onSuccess: ({ systemId, serviceMapId }) => {
      qc.invalidateQueries({
        queryKey: ["service-metrics", serviceMapId, systemId],
      });
      qc.invalidateQueries({ queryKey: ["serviceMapId", serviceMapId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
